<template>
  <div
    :class="{
      [size]: true,
      'h5-price-size-wrap': isH5,
      'price-size-wrap': !isH5,
    }"
  >
    <!-- 活动价+原价 -->
    <template v-if="activePrice && originPrice">
      <div class="active-price price" v-html="splitPrice(activePrice)"></div>
      <div class="origin-price price" v-html="splitPrice(originPrice)"></div>
    </template>
    <!-- 仅原价 -->
    <template v-else-if="originPrice">
      <div class="active-price price" v-html="splitPrice(originPrice)"></div>
    </template>
  </div>
</template>

<script>
import { splitPrice, isH5 } from "@saas/components";
export default {
  props: {
    originPrice: {
      type: Number,
      default: null,
    },
    activePrice: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "SL2",
    },
  },
  data: function () {
    return {
      splitPrice,
      isH5: isH5(),
    };
  },
};
</script>

<style lang="scss" scoped>
.price-size-wrap {
  display: flex;
  align-items: flex-end;
  .price {
    display: flex;
    font-family: AvenirLTPro !important;
  }
  ::v-deep .active-price {
    font-weight: 800;
    color: #ff265c;
    display: flex;
    align-items: flex-end;
    line-height: 1;
    margin-right: 3px;
    span {
      line-height: 1;
    }
  }
  ::v-deep .origin-price {
    font-weight: 500;
    color: #858687;
    text-decoration-line: line-through;
    line-height: 1;
    margin-right: 3px;
    .unit {
      font-weight: 400;
    }
  }
}
.price-size-wrap.SL1 {
  ::v-deep .active-price {
    font-size: 18px;
    .unit {
      font-size: 12px;
      margin-bottom: 1px;
    }
  }
  .origin-price {
    font-size: 12px;
  }
}
.price-size-wrap.SL2 {
  ::v-deep .active-price {
    font-size: 22px;
    .unit {
      font-size: 18px;
      margin-bottom: 1px;
    }
    .decimal {
      font-size: 18px;
      margin-bottom: 1px;
    }
  }
  ::v-deep .origin-price {
    font-size: 16px;
    margin-bottom: 1px;
  }
}
.price-size-wrap.ML1 {
  ::v-deep .active-price {
    font-size: 28px;
    .unit {
      font-size: 22px;
    }
    .decimal {
      font-size: 22px;
    }
  }
  ::v-deep .origin-price {
    font-size: 18px;
  }
}

.h5-price-size-wrap {
  display: flex;
  align-items: flex-end;
  .price {
    display: flex;
    font-family: AvenirLTPro !important;
  }
  ::v-deep .active-price {
    font-weight: 800;
    color: #ff265c;
    display: flex;
    align-items: flex-end;
    line-height: 1;
    margin-right: 0.05rem;
    span {
      line-height: 1;
    }
  }
  ::v-deep .origin-price {
    font-weight: 500;
    color: #858687;
    text-decoration-line: line-through;
    line-height: 1;
    margin-right: 0.05rem;
    .unit {
      font-weight: 400;
    }
  }
}
.h5-price-size-wrap.ML1 {
  ::v-deep .active-price {
    font-size: 0.37rem;
    .unit {
      font-size: 0.29rem;
    }
    .decimal {
      font-size: 0.29rem;
    }
  }
  ::v-deep .origin-price {
    font-size: 0.24rem;
  }
}
.h5-price-size-wrap.ML2 {
  ::v-deep .active-price {
    font-size: 0.43rem;
    .unit {
      font-size: 0.29rem;
      margin-bottom: 0.05rem;
    }
    .decimal {
      font-size: 0.32rem;
      margin-bottom: 0.02rem;
    }
  }
  ::v-deep .origin-price {
    font-size: 0.27rem;
    margin-bottom: 0.02rem;
  }
}
.price-size-wrap.ML2 {
  ::v-deep .active-price {
    font-size: 28px;
    .unit {
      font-size: 22px;
      margin-bottom: 1px;
    }
    .decimal {
      font-size: 22px;
      margin-bottom: 1px;
    }
  }
  ::v-deep .origin-price {
    font-size: 20px;
    margin-bottom: 1px;
  }
}
</style>
